import React from "react";

const AdminDataTable = ({
  columns,
  data,
  loading,
  page,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
  sortBy,
  sortOrder,
  onSort,
  verticalAlign = "top",
}) => {
  if (loading) return <div>Loading...</div>;

  const renderSortIcon = (col) => {
    if (!col.sortable) return null;
    if (sortBy !== col.key) return <span className="ms-1">⇅</span>;
    return sortOrder === "asc" ? <span className="ms-1">▲</span> : <span className="ms-1">▼</span>;
  };

  // Helper to render pagination range
  const getPaginationRange = () => {
    const delta = 2; // show 2 pages before and after current
    const range = [];
    for (let i = Math.max(1, page - delta); i <= Math.min(totalPages, page + delta); i++) {
      range.push(i);
    }
    return range;
  };

  return (
    <div className="table-responsive">
      <table
        className="table table-striped table-bordered mytable mb-0"
        style={{ tableLayout: "fixed", width: "100%" }}
      >
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th
                key={i}
                onClick={() => col.sortable && onSort(col.key)}
                style={{
                  width: col.width || "auto",
                  minWidth: col.width || "auto",
                  maxWidth: col.width || "auto",
                  cursor: col.sortable ? "pointer" : "default",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  padding: "6px 8px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                {col.label}
                {renderSortIcon(col)}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length ? (
            data.map((row, index) => (
              <tr key={row._id || index}>
                {columns.map((col, cIndex) => (
                  <td
                    key={cIndex}
                    style={{
                      width: col.width || "auto",
                      minWidth: col.width || "auto",
                      maxWidth: col.width || "auto",
                      textAlign:
                        col.label === "S.No" || col.label === "Action" ? "center" : "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "5px 8px",
                      verticalAlign: col.verticalAlign || verticalAlign || "top",
                    }}
                  >
                    {col.render ? col.render(row, index, page, pageSize) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination and Rows per page */}
      <div className="d-flex justify-content-between align-items-center mt-2 pt-1">
        {/* Rows per page selector */}
        <div>
          <label>
              Show{" "}
              <select
                value={pageSize}
                onChange={(e) => onPageSizeChange(Number(e.target.value))}
                className="form-select form-select-sm d-inline-block w-auto"
              >
                {(() => {
                  const defaultOptions = [10, 50, 100];
                  const opts = new Set(defaultOptions);
                  if (pageSize && !opts.has(Number(pageSize))) opts.add(Number(pageSize));
                  // convert to array and sort ascending
                  return Array.from(opts).sort((a,b)=>a-b).map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ));
                })()}
              </select>{" "}
              entries
            </label>
        </div>

        {/* Pagination */}
        <div>
          <button
            className="btn btn-sm btn-info mx-1"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
          >
            Previous
          </button>

           {getPaginationRange().map((p) => (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              style={{
                backgroundColor: page === p ? "#bf3272" : "white",
                borderColor: "#bf3272",
                color: page === p ? "white" : "#bf3272",
              }}
              className="btn btn-sm mx-1"
            >
              {p}
            </button>
          ))}


          <button
            className="btn btn-sm btn-info mx-1"
            onClick={() => onPageChange(page + 1)}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AdminDataTable);
